<button [ngClass]="{ 'btn-flat': isFlat }" mat-raised-button [disabled]="inactive || disabled" color="accent" type="submit" (click)="onClick($event)">
  <mat-spinner class="mat-spinner-color" *ngIf="isBusy; else text_button" [diameter]="25"> </mat-spinner>

  <ng-template #text_button>{{ text }}</ng-template>
</button>
